module.exports = __webpack_public_path__ + "static/media/KILODE.99825269.mp3";